export const getXAuthOwnerHeader = (organization: string): Object =>
  organization ? { headers: { ['X-auth-owner']: organization } } : {};
